module.exports = __webpack_public_path__ + "static/img/designGuide13.b5c3735.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide13.png
// module id = JGTh
// module chunks = 2